import React from "react";
import { Link } from "react-router-dom";

import { ToggleSwitch } from "../../common/ui_elements";
import { IconTootip, RatingStars } from "../../common/icons";
import { ReaderItem } from "../../../models/reader";
import { AllType } from ".";
import { sortArray, SortBy } from "../../../hooks/useSort";
import { ThSort } from "../../common/ui_elements";
import { isMobile } from "react-device-detect";

type ManageBooksProps = {
  readers: ReaderItem[];
  loading: boolean;
  is_author_book: boolean;
  toggleDisabled: any;
  toggleAll: any;
  toggleAllGlossary: any;
  toggleGlossary: any;
  all: AllType;
  handle_sort: any;
  sort_by: SortBy;
};
const ManageBooks: React.FC<ManageBooksProps> = ({
  readers,
  toggleDisabled,
  toggleAll,
  is_author_book,
  toggleAllGlossary,
  all,
  toggleGlossary,
  loading,
  handle_sort,
  sort_by,
}): JSX.Element => {
  const data: ReaderItem[] = sortArray(readers, sort_by.by, sort_by.sort);
  return (
    <table
      className={`animate_all table bg-light books_table mt-8 table-hover ${
        loading ? "opacity_8 un_clicked" : ""
      }`}
    >
      <thead>
        <tr>
          <ThSort
            handle_sort={handle_sort}
            title="Title"
            id="title"
            colSpan={isMobile ? 1 : 2}
            type={sort_by.by === "title" ? sort_by.sort : undefined}
          />
          <ThSort
            handle_sort={handle_sort}
            title="Level"
            id="level.name"
            type={sort_by.by === "level.name" ? sort_by.sort : undefined}
            colSpan={1}
            className={`${isMobile ? "d-none-portrait" : ""} `}
          />
          <ThSort
            handle_sort={handle_sort}
            title="Rating"
            id="rating"
            type={sort_by.by === "rating" ? sort_by.sort : undefined}
            colSpan={1}
            className={`${isMobile ? "d-none-portrait" : ""} `}
          />
          <th colSpan={1}>
            Active{" "}
            <IconTootip
              id="Active"
              icon="far fa-info-circle"
              tooltip_txt="Show/Hide book for this class group"
            />
            <ToggleSwitch
              classes="ml-2"
              lables={false}
              small
              inline
              disabled={all.readers}
              click={toggleAll.bind(this, "all")}
              id={"35465"}
            />
          </th>
          <th colSpan={1} className={is_author_book ? `d-none` : ""}>
            Vocab Help{" "}
            <IconTootip
              id="Glossary"
              icon="far fa-info-circle"
              tooltip_txt="Choose either a basic list of underlined translations or a more robust option for beginning readers"
            />
            <ToggleSwitch
              classes="ml-2"
              lables={false}
              small
              inline
              colored={false}
              disabled={
                all.glossary === undefined ||
                all.glossary === null ||
                all.glossary === "OFF"
                  ? true
                  : all.glossary === "LESS"
                    ? "neutral"
                    : false
              }
              click={toggleAllGlossary.bind(this, all.glossary)}
              id={"354543"}
            />
          </th>
        </tr>
      </thead>
      <tbody>
        {data.map((reader) => (
          <ReaderRow
            key={`reader_row_${reader.id}`}
            reader={reader}
            is_author_book={is_author_book}
            toggleDisabled={toggleDisabled}
            toggleGlossary={toggleGlossary}
          />
        ))}
      </tbody>
    </table>
  );
};

const ReaderRow = ({
  reader,
  toggleDisabled,
  toggleGlossary,
  is_author_book,
}: {
  reader: ReaderItem;
  toggleDisabled: any;
  toggleGlossary: any;
  is_author_book: boolean;
}) => (
  <tr>
    <td className="img_td">
      <img
        src={is_author_book ? reader.images.cover : reader.images.thumb}
        alt={reader.title}
        draggable="false"
      />
      {isMobile ? (
        <Link
          to={
            is_author_book
              ? `/creatorbook/${reader.url}`
              : `/bookdetails/${reader.url}/${reader.id}`
          }
          className="text-dark  "
        >
          {reader.title}
        </Link>
      ) : (
        ""
      )}
    </td>
    <td className={`${isMobile ? "d-none" : ""} `}>
      <Link
        to={
          is_author_book
            ? `/creatorbook/${reader.url}`
            : `/bookdetails/${reader.url}/${reader.id}`
        }
        className="text-dark"
      >
        {reader.title}
      </Link>
    </td>
    <td className={`${isMobile ? "d-none-portrait" : ""} `}>
      {reader.level.name}
    </td>
    <td className={`${isMobile ? "d-none-portrait" : ""} `}>
      <RatingStars value={reader.rating} id={`rating_${reader.id}`} />{" "}
    </td>
    <td>
      <ToggleSwitch
        disabled={reader.disabled}
        click={toggleDisabled}
        id={reader.id}
        lables={false}
      />
    </td>

    <td className={is_author_book ? `d-none` : ""}>
      <ToggleSwitch
        disabled={
          reader.glossary_show === undefined || reader.glossary_show === null
            ? true
            : reader.glossary_show === "LESS"
              ? "neutral"
              : reader.glossary_show === "OFF"
                ? true
                : false
        }
        click={toggleGlossary}
        id={reader.id}
        lables={true}
        lables_txt={{
          disabled: isMobile ? <i className="fad fa-signal-2"></i> : "Off",
          neutral: isMobile ? <i className="fad fa-signal-alt-1"></i> : "Basic",
          enabled: isMobile ? <i className="fad fa-signal-alt"></i> : "More",
        }}
        colored={false}
      />
    </td>
  </tr>
);

export default ManageBooks;
